import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3b11cdf8"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "customer-activity" };
const _hoisted_2 = { key: 0 };
const _hoisted_3 = { class: "table__header" };
const _hoisted_4 = { class: "table__cell" };
const _hoisted_5 = ["src", "alt"];
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "icon icon-question-12px" }, null, -1));
const _hoisted_7 = { key: 1 };
const _hoisted_8 = {
    key: 2,
    class: "table__cell-description"
};
const _hoisted_9 = { class: "table__header" };
const _hoisted_10 = { class: "table__header" };
const _hoisted_11 = { class: "table__header" };
const _hoisted_12 = {
    key: 1,
    class: "customer-activity__loading"
};
const _hoisted_13 = {
    key: 0,
    class: "customer-activity__modal-title"
};
import { onMounted, reactive, computed } from 'vue';
import { formatDate } from '@/utilities/formatters';
import { InteractionTypes, } from '@/components/oto/customerview/types';
import { useCustomerActivity } from '@/components/oto/customerview/composables';
import BaseLoader from '@/components/_atoms/BaseLoaderSpinner.vue';
import TablePagination from '@/components/_atoms/TablePagination.vue';
import CustomerOrderDetails from '@/components/oto/customerview/components/CustomerOrderDetails.vue';
import { getCustomerInteractions, getOrderInformation } from '@/services/oto/profile';
export default /*#__PURE__*/ _defineComponent({
    __name: 'CustomerActivity',
    props: {
        customerId: {}
    },
    setup(__props) {
        const props = __props;
        const { isPurchase, getInteractionIcon, getInteractionTitle, formatProductsInfo, getStoreInfo, getSellerInfo } = useCustomerActivity();
        const state = reactive({
            tableLoading: true,
            tableData: [],
            pagination: {
                currentPage: 1,
                limit: 10,
                count: 0,
                pageSizeOptions: [10, 25, 30],
            },
            modalLoading: false,
            modalVisible: false,
            orderDetails: {},
        });
        const paginatedData = computed(() => {
            const startIndex = (state.pagination.currentPage - 1) * state.pagination.limit;
            const endIndex = startIndex + state.pagination.limit;
            return state.tableData.slice(startIndex, endIndex);
        });
        const totalRecords = computed(() => state.tableData.length);
        const fetchCustomerInteractions = async () => {
            state.tableLoading = true;
            try {
                const customerInteractionsResponse = await getCustomerInteractions(props.customerId);
                state.tableData = customerInteractionsResponse.data.interactions;
            }
            catch (error) {
                state.tableData = [];
            }
            state.tableLoading = false;
        };
        const handlePageSizeChange = (val) => {
            state.pagination.limit = val;
        };
        const handleCurrentPageChange = (val) => {
            state.pagination.currentPage = val;
        };
        // Modal Handlers
        const handleTableRowClick = (row) => {
            const allowModalTypes = [InteractionTypes.PURCHASE_ON, InteractionTypes.PURCHASE_OFF];
            if (allowModalTypes.includes(row.type)) {
                state.modalVisible = true;
                fetchOrderDetails(row.order.id, row.order.store, row.date);
            }
        };
        const fetchOrderDetails = async (orderId, storeId, orderDate) => {
            state.modalLoading = true;
            try {
                const orderDetailsResponse = await getOrderInformation(props.customerId, orderId, storeId, orderDate);
                state.orderDetails = orderDetailsResponse.data;
            }
            catch (error) {
                state.orderDetails = null;
            }
            state.modalLoading = false;
        };
        onMounted(() => fetchCustomerInteractions());
        return (_ctx, _cache) => {
            const _component_el_tooltip = _resolveComponent("el-tooltip");
            const _component_el_table_column = _resolveComponent("el-table-column");
            const _component_el_table = _resolveComponent("el-table");
            const _component_el_dialog = _resolveComponent("el-dialog");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("h2", null, _toDisplayString(_ctx.$t('base-management.customer-activity.title')), 1),
                    (!state.tableLoading && state.tableData)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                            _createVNode(_component_el_table, {
                                data: paginatedData.value,
                                stripe: "",
                                height: "600",
                                "header-cell-class-name": "table__header-cell",
                                class: "table",
                                onRowClick: handleTableRowClick
                            }, {
                                empty: _withCtx(() => [
                                    _createElementVNode("p", null, _toDisplayString(_ctx.$t('base-management.customer-activity.empty')), 1)
                                ]),
                                default: _withCtx(() => [
                                    _createVNode(_component_el_table_column, {
                                        prop: "campaignName",
                                        label: _ctx.$t('base-management.customer-activity.interactions'),
                                        width: "380"
                                    }, {
                                        header: _withCtx(({ column }) => [
                                            _createElementVNode("p", _hoisted_3, _toDisplayString(column.label), 1)
                                        ]),
                                        default: _withCtx(({ row }) => [
                                            _createElementVNode("div", _hoisted_4, [
                                                _createElementVNode("img", {
                                                    src: require(`@/assets/svgs/${_unref(getInteractionIcon)(row.type)}.svg`),
                                                    alt: _unref(getInteractionTitle)(row)
                                                }, null, 8, _hoisted_5),
                                                _createElementVNode("div", null, [
                                                    _createElementVNode("p", {
                                                        class: _normalizeClass(['table__cell-title', _unref(isPurchase)(row.type) && 'table__cell--highlight'])
                                                    }, [
                                                        _createTextVNode(_toDisplayString(_unref(getInteractionTitle)(row)) + " ", 1),
                                                        (_unref(isPurchase)(row.type) && !row.order.products)
                                                            ? (_openBlock(), _createBlock(_component_el_tooltip, {
                                                                key: 0,
                                                                content: _ctx.$t('base-management.customer-activity.inconsistencies'),
                                                                placement: "bottom",
                                                                "popper-class": "customer-activity__tooltip"
                                                            }, {
                                                                default: _withCtx(() => [
                                                                    _hoisted_6
                                                                ]),
                                                                _: 1
                                                            }, 8, ["content"]))
                                                            : _createCommentVNode("", true)
                                                    ], 2),
                                                    (_unref(isPurchase)(row.type))
                                                        ? (_openBlock(), _createElementBlock("p", {
                                                            key: 0,
                                                            class: _normalizeClass(['table__cell-description', _unref(isPurchase)(row.type) && 'table__cell--highlight'])
                                                        }, _toDisplayString(_unref(formatProductsInfo)(row.order)), 3))
                                                        : (row.type === _unref(InteractionTypes).RESCHEDULE)
                                                            ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.$t('base-management.customer-activity.scheduled-reminder', {
                                                                date: _unref(formatDate)(row.date),
                                                                time: _unref(formatDate)(row.date, 'HH:mm'),
                                                            })), 1))
                                                            : (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(row.campaignName), 1))
                                                ])
                                            ])
                                        ]),
                                        _: 1
                                    }, 8, ["label"]),
                                    _createVNode(_component_el_table_column, {
                                        prop: "storeName",
                                        label: _ctx.$t('base-management.customer-activity.store')
                                    }, {
                                        header: _withCtx(({ column }) => [
                                            _createElementVNode("p", _hoisted_9, _toDisplayString(column.label), 1)
                                        ]),
                                        default: _withCtx(({ row }) => [
                                            _createElementVNode("p", null, _toDisplayString(_unref(getStoreInfo)(row)), 1)
                                        ]),
                                        _: 1
                                    }, 8, ["label"]),
                                    _createVNode(_component_el_table_column, {
                                        prop: "sellerName",
                                        label: _ctx.$t('base-management.customer-activity.seller')
                                    }, {
                                        header: _withCtx(({ column }) => [
                                            _createElementVNode("p", _hoisted_10, _toDisplayString(column.label), 1)
                                        ]),
                                        default: _withCtx(({ row }) => [
                                            _createElementVNode("p", null, _toDisplayString(_unref(getSellerInfo)(row)), 1)
                                        ]),
                                        _: 1
                                    }, 8, ["label"]),
                                    _createVNode(_component_el_table_column, {
                                        prop: "date",
                                        label: _ctx.$t('base-management.customer-activity.date'),
                                        width: "180"
                                    }, {
                                        header: _withCtx(({ column }) => [
                                            _createElementVNode("p", _hoisted_11, _toDisplayString(column.label), 1)
                                        ]),
                                        default: _withCtx(({ row }) => [
                                            _createElementVNode("p", null, _toDisplayString(_unref(formatDate)(row.date)), 1)
                                        ]),
                                        _: 1
                                    }, 8, ["label"])
                                ]),
                                _: 1
                            }, 8, ["data"]),
                            _createVNode(TablePagination, {
                                total: totalRecords.value,
                                currentPageSize: state.pagination.limit,
                                currentPage: state.pagination.currentPage,
                                pageSizeOptions: state.pagination.pageSizeOptions,
                                "onUpdate:currentPage": handleCurrentPageChange,
                                "onUpdate:pageSize": handlePageSizeChange
                            }, null, 8, ["total", "currentPageSize", "currentPage", "pageSizeOptions"])
                        ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                            _createVNode(BaseLoader)
                        ]))
                ]),
                _createVNode(_component_el_dialog, {
                    modelValue: state.modalVisible,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((state.modalVisible) = $event)),
                    width: "885",
                    "align-center": "",
                    "show-close": !state.modalLoading
                }, {
                    header: _withCtx(() => [
                        (!state.modalLoading)
                            ? (_openBlock(), _createElementBlock("h3", _hoisted_13, _toDisplayString(_ctx.$t('base-management.customer-activity.purchase-details')), 1))
                            : _createCommentVNode("", true)
                    ]),
                    default: _withCtx(() => [
                        _createVNode(CustomerOrderDetails, {
                            loading: state.modalLoading,
                            "order-details": state.orderDetails
                        }, null, 8, ["loading", "order-details"])
                    ]),
                    _: 1
                }, 8, ["modelValue", "show-close"])
            ], 64));
        };
    }
});
